const system_limit = {
    limit_exceeded: 'به محدودیت سیستم رسیده‌اید. لطفاً برای کمک با پشتیبانی تماس بگیرید.',
};
export default Object.freeze(system_limit);
